import { SanitizedAssigneeSelection, ScheduleTarget } from '@chilipiper/api-client/src/handoff'
import { RoundRobinAvailableAttendees } from '@chilipiper/api-client/src/user-availability'
import { indexBy } from 'remeda'

export const convertToResolvedAssignees = ({
  selectedAssignees,
  availableRoundRobinAssignees,
}: {
  selectedAssignees: SanitizedAssigneeSelection[]
  availableRoundRobinAssignees?: RoundRobinAvailableAttendees[]
}): ScheduleTarget[] => {
  if (selectedAssignees.length === 0) {
    return []
  }

  const mappedAvailableAssignees = indexBy(
    availableRoundRobinAssignees || [],
    item => item.distributionId
  )

  return selectedAssignees.flatMap(assignee => {
    if (assignee.type === 'User') {
      return {
        type: 'User' as const,
        id: assignee.id,
      }
    }

    if (assignee.type === 'UserFromDistribution') {
      return {
        type: 'User' as const,
        id: assignee.user,
      }
    }

    if (assignee.type === 'FromDistribution') {
      const availableAssignee = mappedAvailableAssignees[assignee.distributionId]

      if (!availableAssignee) {
        return []
      }

      if (availableAssignee.type === 'StrictRoundRobin') {
        return {
          type: 'User' as const,
          id: availableAssignee.userId,
        }
      } else {
        return {
          type: 'AvailableUsers' as const,
          ids: availableAssignee.userIds,
        }
      }
    }

    return []
  })
}
